import { createFeatureSelector, createSelector } from '@ngrx/store';
import { addExtensionFeatureKey, AddExtensionState } from './add-extension.reducer';

const getAddExtensionFeature = createFeatureSelector<AddExtensionState>(addExtensionFeatureKey);

export const getAddExtensionCallState = createSelector(getAddExtensionFeature, (state) => {
   return state.callState;
});
